module.exports = __webpack_public_path__ + "static/media/quiz.a92946c2.png";